<template>
  <div>
    <el-page-header @back="close" :content="(form.id > 0 ? '编辑' : '新增') + '计费配置'"></el-page-header>
    <el-row>
      <el-col :span="12" :offset="3">
        <el-form :model="form" :rules="rules" ref="form" :status-icon="true" label-width="130px">
          <el-form-item label="国家代码" prop="gjdm" :error="errors.gjdm">
            <el-input v-model="form.gjdm"></el-input>
          </el-form-item>
          <el-form-item label="国家英文缩写" prop="gjywsx" :error="errors.gjywsx">
            <el-input v-model="form.gjywsx"></el-input>
          </el-form-item>
          <el-form-item label="国家中文名称" prop="gjzwsx" :error="errors.gjzwsx">
            <el-input v-model="form.gjzwsx"></el-input>
          </el-form-item>
          <el-form-item label="号段" prop="segment" :error="errors.segment">
            <el-input v-model="form.segment"></el-input>
          </el-form-item>
          <el-form-item label="单价" prop="price" :error="errors.price">
            <el-input-number v-model="form.price"></el-input-number>
          </el-form-item>
          <el-form-item label="类型" prop="type.value" :error="errors.type">
            <RemoteSelect v-model="form.type.value" :url="'/dict/list/sms/type'"></RemoteSelect>
          </el-form-item>
          <el-form-item>
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RemoteSelect from '@/components/RemoteSelect'

export default {
  components: {
    RemoteSelect
  },
  data() {
    return {
      form: {
        id: this.$route.params.id,
        gjdm: "",
        segment: "",
        gjywsx: "",
        gjzwsx: "",
        price: 0,
        type: {},
      },
      rules: {
        gjdm: [
          {required: true, message: "请填写国家代码"}
        ],
        gjywsx: [
          {required: true, message: "请填写国家英文缩写"},
        ],
        gjzwsx: [
          {required: true, message: "请填写国家中文名称"},
        ],
        price: [
          {required: true, message: "请填写单价"},
        ],
        "type.value": [
          {required: true, message: "请选择类型"}
        ],
      },
      errors: {},
    }
  },
  beforeMount() {
    if (this.form.id > 0) {
      this.$axios.get("/price/get/" + this.form.id).then(result => {
        this.$utils.merge(this.form, result);
      })
    }
  },
  methods: {
    submit() {
      let url = this.form.id > 0 ? "/price/edit" : "/price/save";
      this.$utils.submit(this.$refs.form, url, this.form, () => {
        this.$router.go(-1);
      }, (data) => {
        this.errors = data;
      });
    },
    close() {
      this.$router.go(-1);
    }
  }
}
</script>